import { addClass, getSysEnv } from '@vas2t-lowcode/utils';

/**
 * 根据环境添加类名
 * @param container - dom对象
 * @param prefix - 类名前缀
 */
export const configClassNameByEnv = (container: Element, prefix = 'lowcode-wrap') => {
  const isShare = location.href.includes('#/share') || location.href.includes('#/dialog');
  const sysEnv = getSysEnv();
  if (sysEnv.has('pc')) {
    addClass(container, `${prefix}--pc`);
    const sharePageClassName = isShare ? 'share' : 'normal';
    addClass(container, `${prefix}--${sysEnv.has('pc-wps') ? 'wps' : sharePageClassName}`);
  } else {
    addClass(container, `${prefix}--mobile`);
  }

  if (sysEnv.has('wechat')) {
    addClass(container, `${prefix}--wechat`);
  }

  if (sysEnv.has('ipad')) {
    addClass(container, `${prefix}--ipad`);
  }
};
